import { Button, ComboBox, FLink } from '@components';
import { opcoesRenda } from '@pages/Beneficios/components/Renda/utils';
import { PLANO_TAESA } from '@utils/plans';
import { parse } from 'date-fns';
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { opcoesCard } from '../../../../store/modules/simulacaoBeneficio/actions';
import {
  ABONO_ANUAL,
  BENEFICIOS,
  // CALCULADORA_EXAURIMENTO,
  CONTRACHEQUE,
  CONVERSAO_BENEFICIOS,
  EXTRADO_SALDO_CONTAS_ASSISTIDO_PENSIONISTA,
  INFORME_RENDIMENTOS,
  MEMORIA_CALCULO,
  PARCELA_ADICIONAL,
  PERCENTUAL_RENDA_MENSAL_ABSOLUTE_PATH,
  RESERVA_MATEMATICA,
  SAQUE_VISTA,
  // SIMULACAO_TRANSFORMACAO_PLA,
  // FORM_TRANSFORMACAO_PLA,
  TRANSFORMACAO_BENEFICIO,
  VALOR_BENEFICIO,
} from '../../../utils/paths';

const DATA_DE_CORTE_ADMISSAO_PARTICIPANTE = '2018-05-01';

const links = [
  {
    label: 'Contracheque',
    to: CONTRACHEQUE,
    id: 'contracheque',
    type: 'link',
  },
  {
    label: 'Extrato de Saldo de Contas',
    to: EXTRADO_SALDO_CONTAS_ASSISTIDO_PENSIONISTA,
    id: 'extrato_pensionista_assistido',
    type: 'link',
  },
  {
    label: 'Conversão de Benefícios',
    to: CONVERSAO_BENEFICIOS,
    id: 'simular_conversao_beneficio',
  },
  {
    label: 'Informe Anual de Rendimentos',
    to: INFORME_RENDIMENTOS,
    id: 'informe_rendimento',
  },
  {
    label: 'Contracheque de Adiantamento de Abono Anual',
    to: ABONO_ANUAL,
    id: 'abono_anual',
  },
  {
    label: 'Memória do cálculo de benefício',
    to: MEMORIA_CALCULO,
    id: 'memoria_calculo',
  },
  {
    label: 'Parcela adicional',
    to: PARCELA_ADICIONAL,
    id: 'parcela_adicional',
  },
  {
    label: 'Percentual Recebimento de Renda Mensal',
    to: PERCENTUAL_RENDA_MENSAL_ABSOLUTE_PATH,
    id: 'alterar_recebimento',
  },
  {
    label: 'Reserva Matemática',
    to: RESERVA_MATEMATICA,
    id: 'reserva_matematica',
  },
  {
    label: 'Saque à vista',
    to: SAQUE_VISTA,
    id: 'saque_vista',
  },

  // {
  //   label: 'Calculadora de Exaurimento',
  //   to: CALCULADORA_EXAURIMENTO,
  //   id: 'alterar_recebimento',
  // },

  {
    label: 'Transformação de benefício',
    to: TRANSFORMACAO_BENEFICIO,
    id: 'transformacao_reserva',
  },

  {
    label: 'Valor benefício (CPA)',
    to: VALOR_BENEFICIO,
    id: 'cpa',
  },
  // {
  //   label: 'Simulação de Transformação de benefício do Plano A',
  //   to: SIMULACAO_TRANSFORMACAO_PLA,
  //   id: 'transformacao_reserva_planoA',
  // },
  // {
  //   label: 'Solicitação de Transformação de benefício do Plano A',
  //   to: FORM_TRANSFORMACAO_PLA,
  //   id: 'transformacao_reserva_planoA',
  // },
];

export const BeneficiosCard = () => {
  const [tipoRendaMensal, setTipoRendaMensal] = useState(undefined);
  const [opcoesRendaSelect, setOpcoesRendaSelect] = useState(opcoesRenda);
  const user = useSelector((state) => state.user);
  const telasAtivas = useSelector((state) => state.telasDisponiveis);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleBeneficiosPage = () => {
    dispatch(opcoesCard({ tipoRendaMensal }));
    navigate(BENEFICIOS);
  };

  useEffect(() => {
    if (
      parse(user.dadosPessoais.dataAdmissao, 'yyyy-MM-dd', new Date()) >=
        parse(DATA_DE_CORTE_ADMISSAO_PARTICIPANTE, 'yyyy-MM-dd', new Date()) ||
      user.plano === PLANO_TAESA
    ) {
      setOpcoesRendaSelect(
        opcoesRenda.filter((item) => {
          return item.label === 'Percentual Saldo';
        })
      );
    }
  }, [user.dadosPessoais.dataAdmissao, user.plano]);

  return (
    <div className="card">
      <div className="card-body h-100">
        <h1 className="ts-20 fw-bold">Benefícios</h1>
        {telasAtivas.simular_beneficio && (
          <>
            <p className="ts-14 text-muted mb-32 mt-2">
              Realize aqui a simulação do seu benefício.
            </p>
            <ComboBox
              className="mb-4 mt-32"
              options={opcoesRendaSelect.map((x) => {
                return { value: x.value, label: x.label };
              })}
              defaultValue={tipoRendaMensal}
              onChange={setTipoRendaMensal}
              label="Tipo de renda mensal"
            />
            <Button onClick={handleBeneficiosPage} disabled={!tipoRendaMensal}>
              Simular
            </Button>
          </>
        )}

        {links.map((link) => {
          if (link.id) {
            if (telasAtivas[link.id]) {
              return (
                <Fragment key={link.to}>
                  <hr className="my-4" />
                  <FLink to={link.to} icon>
                    {link.label}
                  </FLink>
                </Fragment>
              );
            }

            return null;
          }

          return (
            <Fragment key={link.to}>
              <hr className="my-4" />
              <FLink to={link.to} icon>
                {link.label}
              </FLink>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};
